export const MAIN = 'MAIN'
export const EXTRA = 'EXTRA'
